<template>
  <base-popup v-if="show" @close="close()">
    <template #header>
      <h3>Nommer l'élément ajouté</h3>
    </template>
    <template #bodyContent>
      <input type="text" v-model="inputText" class="text-input" placeholder="Entrez un nom..." @keyup.enter="namedAction(inputText)"/>
    </template>
    <template #footer>
      <button @click="close()" class="text-input-button cancel">
        Annuler
      </button>
      <button @click="namedAction(inputText)" class="text-input-button validate">
        Valider
      </button>
    </template>
  </base-popup>
</template>

<script>
import BasePopup from './Base/BasePopup.vue'

export default {
  name: 'NameElementPopup',
  components: {
    BasePopup
  },
  props: {
    show: {
      type: Boolean,
      required: true
    },
    defaultName: {
      type: String,
      required: true
    },
    label: {
      type: String,
      default: "Nom de l'élément"
    }
  },
  mounted() {
    this.inputText = this.defaultName;
  },
    watch: {
        defaultName: function() {
            this.inputText = this.defaultName;
        }
  },
    data() {
        return {
            inputText: '',
        }
    },
    emits: ['close', 'named'],
    methods: {
        close: function() {
            this.inputText = this.defaultName;
            this.$emit("close");
        },
        namedAction: function(text) {
            if (text) {
                this.$emit('named', text);
            } else {
                this.$emit('named', "");
            }
            this.inputText = this.defaultName;
        },
    }
}
</script>

<style scoped>
.text-input {
  width: 100%;
  padding: 0.5rem;
  background-color: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 0.375rem;
  color: #e5e7eb;
  margin-bottom: 1rem;
}

.text-input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.4);
}

.text-input-button {
  padding: 0.5rem 1rem;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  font-weight: 500;
  transition: all 0.2s ease;
}

.text-input-button.cancel {
  background-color: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: #e5e7eb;
}

.text-input-button.cancel:hover {
  background-color: rgba(255, 255, 255, 0.15);
  border-color: rgba(255, 255, 255, 0.3);
}

.text-input-button.validate {
  background-color: rgba(59, 130, 246, 0.2);
  border: 1px solid rgba(59, 130, 246, 0.3);
  color: #3b82f6;
}

.text-input-button.validate:hover {
  background-color: rgba(59, 130, 246, 0.3);
  border-color: #3b82f6;
}
</style> 